<template>
  <div class="tag">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .tag {
    @apply
      px-2
      py-0.5
      mb-0.5
      mx-0.5
      text-sm
      uppercase
      inline-block
      text-ctm-primary
      bg-ctm-secondary;
  }
</style>